// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7bd1e271","453":"2f08de01"}[chunkId] + ".chunk.js";
};